import { LicenseInfo } from '@mui/x-license';

export const applyKeyMUI = () => {
    const muiKey = process.env.REACT_APP_MUI_KEY;

    if (!muiKey) {
        console.warn('MUI X License key not found. Please set REACT_APP_MUI_KEY environment variable.');
        return;
    }

    // Solo mostrar la licencia en desarrollo para debugging
//     if (process.env.NODE_ENV === 'development') {
//
//     }
    console.log("MUI Key configured:", muiKey.substring(0, 10) + '...');
    LicenseInfo.setLicenseKey(muiKey);
}
